import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
    name: "WearehouseManagement",
    components: {
    FormModal,
    Loading,
    BTooltip, BButton, BCollapse, BCard, BFormGroup, BFormInput, BTable,
    ProductSearch, 
    },
    directives: {
    'b-toggle': VBToggle,
    },
    mixins: [mixins],
    data() {
        return {
            selectedStore: [],
            stores: [],
            productSelect: null,  
            destinationAgency: null,
            isButtonDisabled: false,
            productSku: "", 
            product: "", 
            productId: "",
        }
    },
    mounted() {
        this.loadStores();
    },
    methods: {
        async loadStores(){
            try {
                const response = await this.$axios.get("admin/stores");
                this.stores = response.data.data.stores;
            } catch (e) {
                this.$root.notify(e);
            } 
        },
        selectProduct(product) {
            if(this.product){
                this.$root.notify(
                    "بیشتر از یک محصول نمیشه وارد کرد.",
                    "warning"
                );
                return;
            }
            this.product = product;
            this.product.varieties.forEach(variety => {  
                const foundBalance = variety.store_items.find(item => item.store_id == this.selectedStore.id);  
                variety.quantity = foundBalance ? foundBalance.balance : 0;  
            });  
        },
        async requestProduct() {
            try {
                if(this.product){
                    this.$root.notify(
                        "بیشتر از یک محصول نمیشه وارد کرد.",
                        "warning"
                    );
                    return;
                }
                this.disabled = true;
                const response = await this.$axios.get("admin/mini_orders/search", {
                    params: {
                        sku: this.productSku,
                        refund: false,
                    },
                });
                const variety = response.data.data.variety;
                const productId = variety.product.id;
                const responseProduct = await this.$axios.get("admin/products/" + productId);
                if(this.selectedStore.id == 1 && responseProduct.data.data.product.stocktaking_at){
                    this.$root.notify(
                        "این محصول یکبار انبار گردانی شده است.",
                        "warning"
                    );
                }else if(this.selectedStore.id == 2 && responseProduct.data.data.product.center_stocktaking_at){
                        this.$root.notify(
                            "این محصول یکبار انبار گردانی شده است.",
                            "warning"
                        );
                }
                this.product = responseProduct.data.data.product;
                this.product.varieties.forEach(variety => {  
                    const foundBalance = variety.all_stores_balance.find(item => item.store_id == this.selectedStore.id);  
                    variety.quantity = foundBalance ? foundBalance.balance : 0;  
                });
                
            } catch (e) {
                this.$root.notify(e);
            } finally {
                this.disabled = false;
                this.$nextTick(() => {  
                    this.$refs.productSku.focus();  
                });  
            }
        },
        async submitData() {  
            const data = {  
                store_id: this.selectedStore.id,
                product_id: this.product.id,  
                varieties: this.product.varieties.map(variety => ({  
                    id: variety.id,  
                    balance: variety.quantity,  
                }))  
            };  

            try {  
                const response = await this.$axios.post('admin/store-taking',data);  
                this.$root.notify(response.data.message, 'success');
                this.product = null; 
            } catch (error) {  
                this.$root.notify(error)
            }  
        }  
    }
}
